import './SubscriptionRelativesLinks.css';

import { Button } from 'antd';
import { AI_DETAIL_PAGE_PATH } from '../../pages/subscriptions/ai/AIDetailPage';
import { CONTACTS_PAGE_PATH } from '../../pages/contacts/ContactsPage';
import { SUBSCRIPTIONS_CHATS_PAGE_PATH } from '../../pages/subscriptions/SubscriptionChatsPage';
import {
  BellFilled,
  ContactsFilled,
  MessageFilled,
  RobotFilled,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ICompany, IPlan, ISubscription } from '@leedpulse-monorepo/interfaces';
import { COMPANIES_PAGE_PATH } from '../../pages/companies/CompaniesPage';
import { useContext, useState } from 'react';
import AuthenticationContext from '../../contexts/auth/AuthenticationContext';
import { EProductType, UserRole } from '@leedpulse-monorepo/enums';
import ResetDemoDataModal from '../@shared/subscriptions/ResetDemoDataModal/ResetDemoDataModal';

interface SubscriptionRelativesLinksProps {
  company?: ICompany | null;
  subscription?: ISubscription | null;
  plan?: IPlan | null;
};

const SubscriptionRelativesLinks: React.FC<SubscriptionRelativesLinksProps> = (
  { company, subscription, plan }
) => {
  const navigate = useNavigate();
  const auth = useContext(AuthenticationContext);

  const [isResetModalOpen, setIsResetModalOpen] = useState(false);

  return (
    <div className="subscription-relatives-links">
      <Button
        type={'primary'}
        style={{
          backgroundColor: 'var(--warning-color)',
          color: 'black',
        }}
        icon={<RobotFilled />}
        onClick={(e) => {
          e.preventDefault();
          navigate(AI_DETAIL_PAGE_PATH.replace('/', ''));
        }}
        href={AI_DETAIL_PAGE_PATH.replace('/', '')}
        target="_blank"
      >
        Configurer l'IA
      </Button>

      <Button
        type={'primary'}
        icon={<ContactsFilled />}
        onClick={(e) => {
          e.preventDefault();
          navigate(CONTACTS_PAGE_PATH.replace('/', ''));
        }}
        href={CONTACTS_PAGE_PATH.replace('/', '')}
        target="_blank"
      >
        Voir les contacts
      </Button>

      <Button
        type={'primary'}
        icon={<MessageFilled />}
        onClick={(e) => {
          e.preventDefault();
          navigate(SUBSCRIPTIONS_CHATS_PAGE_PATH.replace('/', ''));
        }}
        href={SUBSCRIPTIONS_CHATS_PAGE_PATH.replace('/', '')}
        target="_blank"
      >
        Voir les conversations
      </Button>

      {
        plan?.product === EProductType.LEEDFLOW && (
          <Button
            type={'primary'}
            icon={<BellFilled />}
            onClick={(e) => {
              e.preventDefault();
              navigate(`${COMPANIES_PAGE_PATH}/${company?.id}`);
            }}
            href={`${COMPANIES_PAGE_PATH}/${company?.id}`}
            target="_blank"
          >
            Voir l'entreprise
          </Button>
        )
      }

      {[UserRole.owner, UserRole.admin].includes(auth.authentication?.role ?? UserRole.guest) && subscription?.settings.demo_account &&
        <>
          <Button
            type={'primary'}
            style={{
              backgroundColor: 'var(--danger-color)',
              color: 'var(--background-secondary-color)',
              marginLeft: 'auto',
            }}
            icon={<BellFilled />}
            onClick={async (e) => {
              e.preventDefault();
              setIsResetModalOpen(true);
            }}
          >
            Réinitialiser les données de démonstration
          </Button>

          <ResetDemoDataModal
            subscriptions={[subscription?.id ?? '']}
            open={isResetModalOpen}
            resetCallback={() => {
              setIsResetModalOpen(false);
              window.location.reload();
            }}
            onCancel={() => setIsResetModalOpen(false)}
          />
        </>
      }
    </div>
  );
};

export default SubscriptionRelativesLinks;
